import React from "react";
import './Contatti.css'
import Form from '../Form/Form';
import Home2 from "../Home/Home2";
import { Container, Row, Col } from "react-bootstrap";
import {MyAnimatedTypo,MyAnimatedTypo2} from "../Moving";
import imageUrl1 from "../../Assets/phone.png";
import {
  SiGooglemaps
} from "react-icons/si";
import {
  FcPhone
} from "react-icons/fc";
import {
  AiOutlineMail,
  AiOutlineGlobal
} from "react-icons/ai";



function Contatti() {
  return (
    <section>
      <Container fluid className="home-section" id="contatti">
        <Container className="Contatti-content"> 
            <Row md={7} className="Contatti-header">
              <h1 style={{ paddingTop: 40 }}>
              CONTATTI
              </h1>
            </Row>
            <div className="Contatti-rainbow">
                  BAES STUDIO
                  <br></br>
                  DOTT. FABIO BEVILACQUA
                  <br></br>
                  <br></br>
            	<div className="row mb-3">
                <div className="col-md-3" style={{display:"none"}}>
                  <div className="dbox w-100 text-center">
                    <div className="icon d-flex align-items-center justify-content-center">
                        <SiGooglemaps />
                    </div>
                    <div className="text">
                      <p><span></span> Sede Attualmente non disponibile</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="dbox w-100 text-center">
                    <div className="icon d-flex align-items-center justify-content-center">
                        <FcPhone />
                    </div>
                    <div className="text">
                      <p><span></span> <a href="tel://3923474801">3923474801</a></p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="dbox w-100 text-center">
                    <div className="icon d-flex align-items-center justify-content-center">
                      <AiOutlineMail/>
                    </div>
                    <div className="text">
                      <p><span></span> <a href="mailto:fabio.bevilacqua@baes-studio.it">fabio.bevilacqua@baes-studio.it</a></p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3" style={{display:"none"}}>
                  <div className="dbox w-100 text-center">
                    <div className="icon d-flex align-items-center justify-content-center">
                      <AiOutlineGlobal/>
                    </div>
                    <div className="text">
                      <p><span></span> <a href="#">baes-studio.it</a></p>
                    </div>
                  </div>
                </div>
                <Home2 />
						</div>
          </div>
          <Row>
          <div className="formtxt-header">
              <h1 style={{ paddingTop: 20 }}>
              CONTATTACI SUBITO! SCRIVICI PER AVERE MAGGIORI INFORMAZIONI IN MERITO: 
              </h1>
          </div>    
            <Form />
          </Row>
        </Container>  
      </Container>
    </section>
  );
}

export default Contatti;
